import { init as initApm } from '@elastic/apm-rum'

const apm = initApm({

  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: 'tm-insight',

  // Set custom APM Server URL (default: http://localhost:8200)
  serverUrl: 'https://05d8eac373a440baab998a488cbc27c2.apm.us-west-2.aws.cloud.es.io:443',

  // Set service version (required for sourcemap feature)
  serviceVersion: '5.12.0',

  environment: window.location.hostname
})